import KeyIcon from '@mui/icons-material/Key'
import MonitorIcon from '@mui/icons-material/Monitor'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import AnalyticsIcon from '@mui/icons-material/Analytics'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark'
import CreateIcon from '@mui/icons-material/Create'
import SmartToyIcon from '@mui/icons-material/SmartToy'

export const CardDetails = [
  {
    id: 1,
    cardTitle: 'Starter',
    plan: 'Starter Plan',
    // Map these to your actual Stripe Price IDs
    stripePriceIds: {
      monthly: 'price_1O2HvrAVTqhthTXdVMIyYa4v',
      yearly: 'price_1O2I24AVTqhthTXdbe75ROVO',
    },
    pricing: {
      monthly: '29',
      yearly: '19',
    },
    planDescription: 'Perfect for new podcasters building their social presence',
    features: [
      { id: 11, title: 'Social Radar (3 signals)', icon: KeyIcon },
      { id: 22, title: 'Engagement Queue', icon: PhoneAndroidIcon },
      { id: 33, title: 'AI Comment Generation', icon: SmartToyIcon },
      { id: 44, title: '30 signals/month', icon: CreateIcon },
      { id: 45, title: '1,000 AI credits/month', icon: SmartToyIcon },
      { id: 55, title: 'Network & Guest Discovery', icon: MonitorIcon },
      { id: 66, title: 'Analytics', icon: AnalyticsIcon },
    ],
  },
  {
    id: 2,
    cardTitle: 'Growth',
    plan: 'Growth Plan',
    stripePriceIds: {
      monthly: 'price_1O2HwDAVTqhthTXd4Ur75tzP',
      yearly: 'price_1O2I2GAVTqhthTXdqtDO1ME7',
    },
    pricing: {
      monthly: '59',
      yearly: '49',
    },
    planDescription: 'For podcasters ready to scale their audience',
    features: [
      { id: 111, title: 'Social Radar (10 signals)', icon: KeyIcon },
      { id: 222, title: 'Engagement Queue', icon: PhoneAndroidIcon },
      { id: 333, title: 'AI Comment Generation', icon: SmartToyIcon },
      { id: 444, title: '100 signals/month', icon: CreateIcon },
      { id: 445, title: '10,000 AI credits/month', icon: SmartToyIcon },
      { id: 555, title: 'Audience Discovery', icon: MonitorIcon },
      { id: 666, title: 'Advanced Analytics', icon: AnalyticsIcon },
    ],
  },
  {
    id: 3,
    cardTitle: 'Pro',
    plan: 'Pro Plan',
    stripePriceIds: {
      monthly: 'price_1O2I0VAVTqhthTXd3bqlPzut',
      yearly: 'price_1O2I0VAVTqhthTXd3yv1akrY',
    },
    pricing: {
      monthly: '149',
      yearly: '129',
    },
    planDescription: 'Unlimited engagement for podcast networks and agencies',
    features: [
      { id: 1111, title: 'Unlimited Social Radar signals', icon: KeyIcon },
      { id: 2222, title: 'Engagement Queue', icon: PhoneAndroidIcon },
      { id: 3333, title: 'Unlimited AI credits', icon: SmartToyIcon },
      { id: 4444, title: 'Unlimited Audience Discovery', icon: MonitorIcon },
      { id: 5555, title: 'Advanced Analytics', icon: AnalyticsIcon },
      { id: 6666, title: 'Priority Support', icon: BrandingWatermarkIcon },
    ],
  },
]
